<template>
  <v-dialog v-model="dialogCantAccess" max-width="320px">
    <div class="link" slot="activator">
      <slot></slot>
    </div>
    <v-card>
      <v-card-title>
        <v-flex>
          <span class="modal-header">Dificuldades no acesso?</span>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex class="text-xs-right">
          <v-btn class="ma-0" icon @click.native="dialogCantAccess = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-card-title>
      <v-card-text class="pt-0">
        <v-flex xs12>
          <p class="info-hotsite">Para concluir a solicitação, é necessário ter e-mail de acesso ao portal de serviços da administradora do seu condomínio. Caso não tenha este e-mail, preeencha os campos abaixo e entraremos em contato.</p>
        </v-flex>
        <v-form v-model="form" ref="form" name="form-cadastro">
        <v-flex xs12>
          <v-text-field
          label="Nome Completo"
          :value="cantAccess.name"
          @input="updateName"
          :validate-on-blur="true"
          :rules="rules.name"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
          label="Documento (CPF)"
          mask="###-###-###-##"
          :value="cantAccess.document"
          :rules="rules.document"
          :validate-on-blur="true"
          @input="updateDocument"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
          label="Telefone"
          :mask="cantAccess.phone === 11 ? '(##) #####-####' : '(##) ####-#####'"
          :value="cantAccess.phone"
          :rules="rules.phone"
          :validate-on-blur="true"
          @input="updatePhone"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
          label="Email"
          :rules="rules.email"
          :value="cantAccess.email"
          :validate-on-blur="true"
          @input="updateEmail"
          ></v-text-field>
        </v-flex>
      </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
          large
          :loading="cantAccess.loading"
          :disabled="cantAccess.loading"
          v-on:click='sendCantAccess'
          class="btn-hotsite"
          block
          >
          enviar
          <span slot="loader" class="custom-loader">
            <v-icon light>cached</v-icon>
          </span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'cant-access',
  props: ['token'],
  data () {
    return {
      dialogCantAccess: false,
      loading: false,
      form: false,
      rules: {
        name: [
          (v) => !!v || 'Nome em branco',
          (v) => v.length > 2 || 'Precisa conter no minimo 3 caracteres'
        ],
        document: [
          (v) => !!v || 'Documento em branco',
          (v) => this.validaDocumento(v) || 'Documento inválido'
        ],
        phone: [
          (v) => !/[^0-9()-\W]{1,15}/.test(v) || 'Telefone inválido',
          (v) => !!v || 'Telefone em branco',
          (v) => v.length < 12 || 'Telefone inválido',
          (v) => v.length > 9 || 'Telefone inválido'
        ],
        email: [
          (v) => !!v || 'Email em branco',
          (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(v) || 'Email inválido'
        ]
      }
    }
  },
  methods: {
    updateName (value) {
      this.$store.commit('cantAccess/updateName', value)
    },
    updateDocument (value) {
      this.$store.commit('cantAccess/updateDocument', value)
    },
    updatePhone (value) {
      this.$store.commit('cantAccess/updatePhone', value)
    },
    updateEmail (value) {
      this.$store.commit('cantAccess/updateEmail', value)
    },
    sendCantAccess () {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('cantAccess/sendEmail', this.token).then(() => {
          this.dialogCantAccess = false
          this.$store.commit('toastr', {
            color: 'success',
            texto: 'email enviado com sucesso'
          })
        })
      }
    },
    validaDocumento: function (numero) {
      numero = numero.replace(/\D/g, '')
      if (numero.length === 11) {
        let cpf = numero
        let Soma = 0
        var Resto = 0
        if (cpf === '00000000000' ||
        cpf === '11111111111' ||
        cpf === '22222222222' ||
        cpf === '33333333333' ||
        cpf === '44444444444' ||
        cpf === '55555555555' ||
        cpf === '66666666666' ||
        cpf === '77777777777' ||
        cpf === '88888888888' ||
        cpf === '99999999999') {
          return false
        }
        for (let i = 1; i <= 9; i++) {
          Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (11 - i)
        }
        Resto = (Soma * 10) % 11

        if ((Resto === 10) || (Resto === 11)) {
          Resto = 0
        }
        if (Resto !== parseInt(cpf.substring(9, 10))) {
          return false
        }
        Soma = 0
        for (let i = 1; i <= 10; i++) {
          Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (12 - i)
        }
        Resto = (Soma * 10) % 11
        if ((Resto === 10) || (Resto === 11)) {
          Resto = 0
        }
        if (Resto !== parseInt(cpf.substring(10, 11))) {
          return false
        }
        return true
      } else {
        return false
      }
    }
  },
  computed: {
    cantAccess () {
      return this.$store.getters['cantAccess/state']
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.modal-header{
  font-size: 22px !important;
  font-weight: 400;
  line-height: 32px !important;
  letter-spacing: normal !important;
}
</style>



// WEBPACK FOOTER //
// CantAccess.vue?0fa9e50f